import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "../../../shared/api/base-query";
import { pagedQueryFn } from "../../../shared/api/paged-query-fn";
import type { QuerySubscriptionOptions } from "../../../shared/api/query-subscription-options";
import type { IPestDto } from "../shared";
import { Pest } from "../shared/models/pests";

export const pestsApiSlice = createApi({
  reducerPath: "api-pests",
  // https://github.com/reduxjs/redux-toolkit/discussions/2347#discussioncomment-2978038
  refetchOnFocus: false,
  keepUnusedDataFor: Number.MAX_SAFE_INTEGER,
  baseQuery,
  tagTypes: ["PestsList"],
  endpoints: (builder) => ({
    fetchPests: builder.query<Pest[], void>({
      queryFn: pagedQueryFn<IPestDto, Pest[]>({ url: "PestsV2" }, (dtos) => {
        const models: Pest[] = dtos.map((dto) => {
          const model = new Pest(dto.id);
          model.updateFromDto(dto);
          return model;
        });
        models.sort((a: Pest, b: Pest) => a.name.localeCompare(b.name));
        return models;
      }),
      providesTags: ["PestsList"],
    }),
  }),
});

const usePestsEndpoint = pestsApiSlice.endpoints.fetchPests.useQuery;

export function useFetchPests(
  options?: QuerySubscriptionOptions<typeof usePestsEndpoint>
) {
  return usePestsEndpoint(undefined, options);
}
